import type { Testimonio } from '../types/content'

export const testimoniosDestacados: Testimonio[] = [
  {
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    product: 'Mega Pack Cocina Lista',
    quote:
      'Organicé toda mi semana en una tarde. Las listas de compras me ahorran horas. Ya no improviso más la cena.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    product: 'Mega Pack Cocina Lista',
    quote:
      'El Tomo de Viandas me cambió la vida laboral. Llevo tupper todos los días y gasté la mitad en comida este mes.',
  },
  {
    initials: 'RM',
    name: 'Romina M.',
    location: 'Buenos Aires',
    product: 'Mega Pack Cocina Lista',
    quote:
      'Mis domingos dejaron de ser un caos. El sistema de 2 horas es un antes y un después en casa.',
  },
]

export const testimonios: Testimonio[] = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    product: 'Mega Pack + Sistema Total',
    quote:
      'El Tomo de Fiestas me llegó justo antes del cumpleaños de mi hija. Hice todo del sistema y mis invitados me preguntaron si lo había encargado en algún lado.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    product: 'Mega Pack Cocina Lista',
    quote:
      'Con el kit de compras bajé un 40% lo que gastaba en comida. Los bonos solos ya valen el precio del pack entero.',
  },
  {
    initials: 'PA',
    name: 'Paula A.',
    location: 'Neuquén',
    product: 'Mega Pack + Sistema Total',
    quote:
      'El protocolo de 30 días del Sistema Total me cambió los hábitos completamente. Ya no pienso más en qué como — el sistema piensa por mí.',
  },
  {
    initials: 'VL',
    name: 'Valentina L.',
    location: 'Rosario',
    product: 'Mega Pack Cocina Lista',
    quote:
      'Los domingos ahora los disfruto. En 2 horas tengo todo listo y el resto de la semana siento que tengo el control de lo que como.',
  },
  {
    initials: 'DM',
    name: 'Daniela M.',
    location: 'Córdoba',
    product: 'Mega Pack Cocina Lista',
    quote:
      'Mis viandas dejaron de ser un chiste. Ahora mis compañeras me preguntan qué como todos los días. El Tomo 4 es oro puro.',
  },
  {
    initials: 'NR',
    name: 'Natalia R.',
    location: 'Buenos Aires',
    product: 'Mega Pack + Sistema Total',
    quote:
      'Lo compré un domingo a las 10 de la mañana. A las 12 ya tenía la heladera organizada y la comida de la semana lista. No lo podía creer.',
  },
]
